export default __webpack_public_path__ + "static/media/search-form-image.896031e8.png";